<template>
  <div class="home_banner" v-if="list&&list.length>0">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="like_slide" v-for="(item,index) in list" :key="index">
          <template v-if="item.ClickType==0">
            <template v-if="item.ClickUrl">
              <a :href="item.ClickUrl" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'"></a>
            </template>
            <template v-else>
              <span class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'"></span>
            </template>
          </template>
          <router-link v-if="item.ClickType==2" :to="{path:'/carddetails/'+item.ClickUrl}" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'">
          </router-link>
          <router-link v-if="item.ClickType==5" :to="{path:'/market?type='+item.ClickUrl}" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'">
          </router-link>
          <router-link v-if="item.ClickType==6" :to="{path:'/list?type='+item.ClickUrl}" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'">
          </router-link>
          <router-link v-if="item.ClickType==9" :to="{path:'/storedetails/'+item.ClickUrl}" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'">
          </router-link>
          <router-link v-if="item.ClickType==10" :to="{path:isUrl(item.ClickUrl)}" target="_blank" class="bannerDiv" :style="'background-image: url('+item.ImgUrl+')'">
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';
import { getInfo } from "@/api/public";
// ClickType
// case 0:"“浏览器链接”"
// case 1:"客户端活动"
// case 2:"客户端卡片"
// case 3:"组队活动"
// case 4:"组队卖家"
// Case 5:"普通市场"
// case 6:"官方市场”"
// case 7: "卖家"
// case 8: "新手区"
// case 9："官方市场详情【海外】"
// case 10: "官方市场列表【海外】"
// case 11: "官方市场列表【国内】"
// case 12: "官方市场详情【国内】"
//        浏览器链接 = 0,
//        客户端卡片 = 2,
//        组队活动 = 3,
//        组队卖家 = 4,
//        普通市场 = 5,
//        官方市场 = 6,
//        卖家 = 7,
//        新手区=8,
// 9=官方商品详情
//10 = 官方商城列表
export default {
  name: 'likeswiper',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      userInfo: '',
      list: '',
      AreaCode: this.$store.state.activityAreaCode,
      swiperOption: {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      }
    }
  },

  watch: {
    '$store.state.activityAreaCode': {
      deep: true,
      handler(obj) {
        //console.log(obj, 'isSwitch')
        this.AreaCode = obj
      }
    }
  },
  created() {
    this.userInfo = getInfo();
    this.GetAdvertisement()
  },
  methods: {
    isUrl(obj) {
      var obj = JSON.parse(obj)
      var data = '?type=' + obj.Manufacturer + '&s=' + obj.CommodityType + '&t=' + obj.CommoditySeries + '&size=' + obj.CommodityYear + '&Sort=' + obj.Sort + '&SortType=' + obj.SortType;
      return '/list' + data
    },
    /**
 * 根据浏览器语言设置区域数据
 * @returns {string} 返回匹配的区域代码，默认为'US'
 * @description 通过遍历AreaData枚举，匹配浏览器语言设置对应的区域代码
 *              如果浏览器语言包含'zh'，则默认返回'MO'(澳门)
 */
setAreaData() {
      let AreaData = this.$enumInfo.AreaData
      var navlanguage = window.navigator.language
      var data='US'
      console.log(navlanguage,'navlanguage')
      AreaData.map(res => {
        if (res.browserLanguages == navlanguage) {
          data=res.areaCode
        }
        if(navlanguage.indexOf('zh')>-1){
          data='MO'
        }
      })
      return data
    },
    GetAdvertisement() {
      let that = this;
      var AreaID = this.setAreaData()
      console.log(AreaID,'AreaID')
      if (this.userInfo != null) {
        AreaID = this.userInfo.MemberSource
      }
       //let data = { AreaID: AreaID, bannerType: 1, AdType: 1 } // 舊
       //bannerType：0 =》首页Bannerl ，bannerType：1 =》首页Banner2 ，bannerType：2  =》弹出广告
      let data = { AreaID: AreaID, BannerType: 0, ClickType: '' } //新
      this.$get(this.$interface.GetAdvertisement, data).then(res => {
        //console.log(res)
        if (res.Result != 0) {
          that.list = res.Data

        }
      })
    }
  }
}

</script>
<style scoped>
.home_banner {
  width: 1200px;
  overflow: hidden;
  margin: auto;
}

.swiper {
  width: 100%;
  height: 240px;
}

.like_slide,
.like_slide .bannerDiv {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: block;
}

/deep/ .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  opacity: 1;
  background: #ccc;
}

/deep/ .swiper-pagination-bullet-active {
  background: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/swiper/advertisement.vue